export class SensitivityLabelsDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sensitivityLevel",
            "baseName": "sensitivityLevel",
            "type": "string",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityLabelsDetails.attributeTypeMap;
    }
    constructor() {
    }
}
